export interface CustomerAddress {
  addressId: string;
  addressee: string;
  name: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  townCity: string;
  region: string;
  postCode: string;
  countryName: string;
  phone: string;
  email: string;
  webAddress: boolean;
  vatRegNo: string;
  multiLine: string;
}
